import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';


import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';


import { SummaryLoanModel } from '../../models/summary-loan.model'
import { LoanService } from '../../services/loan.service';

import { LoanActionTypes,LoadLoansFailure, LoadLoans, LoadLoansSuccess, LoadLoan, LoadLoanSuccess, LoadLoanFailure, UpdateLoan, UpdateLoanSuccess, UpdateLoanFailure, DeleteLoan,DeleteLoanFailure, DeleteLoanSuccess } from '../actions/loan.actions';

@Injectable()
export class LoanEffects {
  constructor(
    private actions$: Actions,
    private service: LoanService
  ) { }

  /** 🔹 Get All */

  
  loadLoan$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(LoanActionTypes.LoadLoans),
    mergeMap((action: LoadLoans) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryLoanModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadLoansFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadLoansSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadLoansFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadLoanById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(LoanActionTypes.LoadLoan),
        mergeMap((action: LoadLoan) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadLoanSuccess(response)),
            catchError(error => of(new LoadLoanFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateLoan$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(LoanActionTypes.UpdateLoan),
          mergeMap((action: UpdateLoan) =>
            this.service.update(action.payload.loan).pipe(
              switchMap(updated => [
                new UpdateLoanSuccess({ loan: updated }),
              ]),
              catchError(error => of(new UpdateLoanFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteLoan$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(LoanActionTypes.DeleteLoan),
          mergeMap((action: DeleteLoan) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteLoanSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteLoanFailure({ error })))
            )
          )
        ));



}
